export var getMascaras = function getMascaras(state) {
  return state.mascaras;
};
export var getActivas = function getActivas(state) {
  return getMascaras(state).activas;
};
export var getVisibles = function getVisibles(state) {
  return getMascaras(state).visibles;
};
export var getPaneles = function getPaneles(state) {
  return getMascaras(state).paneles;
};